import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/toTop.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-41249ce5"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "rankList"
};
var _hoisted_2 = {
  class: "container"
};
var _hoisted_3 = {
  class: "num"
};
var _hoisted_4 = {
  class: "desc"
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, "领用情况", -1);
});
var _hoisted_6 = {
  key: 0,
  class: ""
};
var _hoisted_7 = {
  class: "my-content"
};
var _hoisted_8 = {
  key: 1,
  class: "box"
};
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0
  }, null, -1);
});
var _hoisted_10 = [_hoisted_9];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_c_date_header = _resolveComponent("c-date-header");
  var _component_van_grid_item = _resolveComponent("van-grid-item");
  var _component_van_grid = _resolveComponent("van-grid");
  var _component_van_col = _resolveComponent("van-col");
  var _component_van_row = _resolveComponent("van-row");
  var _component_van_collapse_item = _resolveComponent("van-collapse-item");
  var _component_van_collapse = _resolveComponent("van-collapse");
  var _component_c_no_data = _resolveComponent("c-no-data");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_c_date_header, {
    type: 2,
    onConfirmDate: _ctx.confrimDate
  }, null, 8, ["onConfirmDate"]), _createVNode(_component_van_grid, {
    class: "grid",
    gutter: 10,
    "column-num": 2
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.summaryData, function (item, index) {
        return _openBlock(), _createBlock(_component_van_grid_item, {
          key: index
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.emptyStringFormat(item.num)), 1), _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.emptyStringFormat(item.desc)), 1)];
          }),
          _: 2
        }, 1024);
      }), 128))];
    }),
    _: 1
  }), _hoisted_5, _ctx.departData.length ? (_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.departData, function (item, index) {
    return _openBlock(), _createBlock(_component_van_collapse, {
      modelValue: _ctx.activeNames,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
        return _ctx.activeNames = $event;
      }),
      border: false,
      class: "mb-2",
      accordion: "",
      key: index
    }, {
      default: _withCtx(function () {
        return [_createVNode(_component_van_collapse_item, {
          name: index,
          "title-class": "my-title",
          title: item.receive_department,
          "value-class": "my-value",
          value: item.release_money + '元'
        }, {
          default: _withCtx(function () {
            return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.reportRequisitionSpareDepUser, function (items, indexs) {
              return _openBlock(), _createElementBlock("div", {
                class: "child",
                key: indexs
              }, [_createVNode(_component_van_collapse, {
                modelValue: _ctx.activeNamess,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                  return _ctx.activeNamess = $event;
                }),
                border: false,
                accordion: "",
                onChange: function onChange($event) {
                  return _ctx.changeUser(index + '-' + indexs, item.receive_department, items.create_oper);
                }
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_van_collapse_item, {
                    name: index + '-' + indexs,
                    "title-class": "my-title",
                    title: items.create_oper,
                    "value-class": "my-value",
                    value: items.release_money
                  }, {
                    default: _withCtx(function () {
                      return [_createElementVNode("div", _hoisted_7, [_ctx.userIndex === index + '-' + indexs ? (_openBlock(true), _createElementBlock(_Fragment, {
                        key: 0
                      }, _renderList(_ctx.userData, function (itemss, indexss) {
                        return _openBlock(), _createElementBlock("div", {
                          class: "row",
                          key: indexss
                        }, [_createVNode(_component_van_row, null, {
                          default: _withCtx(function () {
                            return [_createVNode(_component_van_col, {
                              class: "l",
                              span: "10"
                            }, {
                              default: _withCtx(function () {
                                return [_createTextVNode(_toDisplayString(itemss.stone_name), 1)];
                              }),
                              _: 2
                            }, 1024), _createVNode(_component_van_col, {
                              class: "r",
                              span: "6",
                              offset: "8"
                            }, {
                              default: _withCtx(function () {
                                return [_createTextVNode(_toDisplayString(itemss.release_money) + "元", 1)];
                              }),
                              _: 2
                            }, 1024), _createVNode(_component_van_col, {
                              class: "l l1",
                              span: "16"
                            }, {
                              default: _withCtx(function () {
                                return [_createTextVNode("领用时间：" + _toDisplayString(itemss.receive_date), 1)];
                              }),
                              _: 2
                            }, 1024), _createVNode(_component_van_col, {
                              class: "r r1",
                              span: "7",
                              offset: "1"
                            }, {
                              default: _withCtx(function () {
                                return [_createTextVNode("数量：" + _toDisplayString(itemss.release_nums) + _toDisplayString(itemss.release_unit), 1)];
                              }),
                              _: 2
                            }, 1024), _createVNode(_component_van_col, {
                              class: "l l1",
                              span: "16"
                            }, {
                              default: _withCtx(function () {
                                return [_createTextVNode("供应商：" + _toDisplayString(itemss.supplier_name), 1)];
                              }),
                              _: 2
                            }, 1024)];
                          }),
                          _: 2
                        }, 1024)]);
                      }), 128)) : _createCommentVNode("", true)])];
                    }),
                    _: 2
                  }, 1032, ["name", "title", "value"])];
                }),
                _: 2
              }, 1032, ["modelValue", "onChange"])]);
            }), 128))];
          }),
          _: 2
        }, 1032, ["name", "title", "value"])];
      }),
      _: 2
    }, 1032, ["modelValue"]);
  }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_c_no_data)]))]), _createElementVNode("div", {
    class: "goTop",
    onClick: _cache[2] || (_cache[2] =
    //@ts-ignore
    function () {
      return _ctx.goTop && _ctx.goTop.apply(_ctx, arguments);
    })
  }, _hoisted_10)]);
}